import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import techniciansJobApi from '../../APIs/technicians';
import { useRoot } from '../../context/RootProvider';
import {
  PageHeader,
  ScheduleCalendar,
  SelectDropdown,
  Tabs,
} from '../../designComponents';
import EmptyData from '../../designComponents/NoData';
import { RootState } from '../../store/selectors';
import { requestAPI } from '../../utils';
import { ScheduleContainerStyled } from './style';
const tabItems = [
  { key: 'INPROGRESS', label: 'To Do' },
  { key: 'COMPLETED', label: 'Done' },
];
const Schedule = () => {
  const [activeTabs, setActiveTabs] = useState('INPROGRESS');
  const [selectedYear, setSelectedYear] = useState(
    moment(new Date()).format('YYYY')
  );
  const [selectedMonth, setSelectedMonth] = useState(
    (new Date().getMonth() + 1).toString()
  );
  const scheduleData = useSelector(
    (state: RootState) => state.technicianScheduleData.data
  );

  const { auth } = useRoot();

  const authDate = moment(auth?.createdAt).format('YYYY');

  const authYear = Number(authDate);
  const nextTwoYears = Array.from({ length: 3 }, (_, i) => authYear + i);
  const yearsData = nextTwoYears.map((year) => ({
    label: year.toString(),
    value: year.toString(),
  }));

  const monthsData = Array.from({ length: 12 }, (_, i) => ({
    label: (i + 1).toString().padStart(2, '0'),
    value: (i + 1).toString(),
  }));

  const eventsData = scheduleData.map((schedule) => {
    let status: 'Pending' | 'Active' | 'Completed';

    switch (schedule.job.status) {
      case 'PENDING':
        status = 'Pending';
        break;
      case 'INPROGRESS':
        status = 'Active';
        break;
      case 'COMPLETED':
        status = 'Completed';
        break;
      default:
        throw new Error(`Unexpected status: ${schedule.job.status}`);
    }

    return {
      avatar: schedule.clientId.avatar,
      status,
      title: schedule.job.jobTitle,
      userId: `${schedule._id}`,
    };
  });

  const renderYearMonthSelecctor = () => {
    return (
      <div style={{ display: 'flex', gap: '20px' }}>
        <SelectDropdown
          selected={selectedMonth}
          options={monthsData}
          onSelect={(value: string) => setSelectedMonth(value)}
          placeholder="Month"
        />
        <SelectDropdown
          selected={selectedYear}
          options={yearsData}
          onSelect={(value: string) => setSelectedYear(value)}
          placeholder="Year"
        />
      </div>
    );
  };

  const getTechnicianScheduleData = async () => {
    try {
      await requestAPI(
        techniciansJobApi.getSchedules({
          year: selectedYear,
          month: selectedMonth,
          status: activeTabs,
        })
      );
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong, please try again.');
    }
  };

  useEffect(() => {
    getTechnicianScheduleData();
  }, [activeTabs, selectedMonth, selectedYear]);

  const handleActiveTabs = (key: string) => {
    setActiveTabs(key);
  };

  return (
    <ScheduleContainerStyled>
      <PageHeader
        pageTitle={
          <Tabs
            activeKey={activeTabs}
            items={tabItems}
            onChange={handleActiveTabs}
          />
        }
        showDateFilter={false}
        showFilter={false}
        showSearch={false}
        otherActions={renderYearMonthSelecctor()}
      />
      {eventsData.length > 0 ? (
        <>
          <ScheduleCalendar
            events={eventsData}
            month={Number(selectedMonth)}
            year={Number(selectedYear)}
          />
        </>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <EmptyData message="No job schedule in this date!!!" />
        </div>
      )}
    </ScheduleContainerStyled>
  );
};

export default Schedule;
